import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
interface AudienceCardProps {
  type: 'for' | 'not-for';
  title: string;
  items: string[];
  icon: React.ReactNode;
}
export function AudienceCard({
  type,
  title,
  items,
  icon
}: AudienceCardProps) {
  const isFor = type === 'for';
  const bgColor = isFor ? 'bg-[#D4AF37]/5' : 'bg-[#FF3B3B]/5';
  const borderColor = isFor ? 'border-[#D4AF37]/20' : 'border-[#FF3B3B]/20';
  const titleColor = isFor ? 'text-[#D4AF37]' : 'text-[#FF3B3B]';
  const iconColor = isFor ? 'text-[#D4AF37]' : 'text-[#FF3B3B]';
  const checkmark = isFor ? '✓' : '✕';
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className={`${bgColor} border ${borderColor} rounded-2xl p-8 shadow-[0_0_20px_rgba(0,0,0,0.5)]`} data-id="element-222">
      <h3 className={`text-2xl font-serif font-bold ${titleColor} mb-6 flex items-center gap-3`} data-id="element-223">
        {icon}
        {title}
      </h3>
      <ul className="space-y-4" data-id="element-224">
        {items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-225">
            <span className={`${iconColor} mt-1 font-bold`} data-id="element-226">{checkmark}</span>
            <span className="text-[#E8E0D0]" data-id="element-227">{item}</span>
          </li>)}
      </ul>
    </motion.div>;
}